export function getRid() {
  let rid = localStorage.getItem("rid");
  if (!rid) {
    rid = crypto.randomUUID();
    localStorage.setItem("rid", rid);
  }
  return rid;
}
